function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#DC1B20;stroke:#DB1F26;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Group 2");

var _ref4 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-70.000000, -21.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(70.000000, 21.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 6.315789)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "8,1 0.7,8.8 1.7,9.9 8,3.2 14.3,9.9 15.3,8.8  "
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.000000, 4.198565) rotate(-180.000000) translate(-7.000000, -4.198565) translate(0.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "6,-1.2 -1.3,6.6 -0.3,7.6 6,1 12.3,7.6 13.3,6.6  "
})))));

var SvgCloseRed = function SvgCloseRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 17",
    style: {
      enableBackground: "new 0 0 16 17"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close_red.0b2fcc04.svg";
export { ForwardRef as ReactComponent };